import { render, staticRenderFns } from "./ResourceCard2.vue?vue&type=template&id=00e393a5"
import script from "./ResourceCard2.vue?vue&type=script&lang=js"
export * from "./ResourceCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports